import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { ReportDownload } from './ReportDownload.js';
import { i18n } from '../i18n/translate.js';
import { DesignSystem } from '@everfi/design-system';
import { FAIcon } from './fa-icon/component.js';
import { Layout } from '../core/components/Layout/component.js';
import { Typography } from '../core/components/Typography/component.js';
import { Select } from '../core/components/Select/component.js';

var PaginationHeader = /*#__PURE__*/function (_React$Component) {
  function PaginationHeader(props) {
    var _this;

    _classCallCheck(this, PaginationHeader);

    _this = _callSuper(this, PaginationHeader, [props]);

    _defineProperty(_this, "onChange", function (pageSize) {
      _this.props.changePageSize(pageSize.value);
    });

    return _this;
  }

  _inherits(PaginationHeader, _React$Component);

  return _createClass(PaginationHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activePage = _this$props.activePage,
          activeDisplayType = _this$props.activeDisplayType,
          clearFilters = _this$props.clearFilters,
          closeTimeoutModal = _this$props.closeTimeoutModal,
          dataSize = _this$props.dataSize,
          downloadIcon = _this$props.downloadIcon,
          downloadLabel = _this$props.downloadLabel,
          downloadUrl = _this$props.downloadUrl,
          downloadProcessing = _this$props.downloadProcessing,
          downloadTimedOut = _this$props.downloadTimedOut,
          filterDisplayed = _this$props.filterDisplayed,
          downloadAction = _this$props.downloadAction,
          downloadParams = _this$props.downloadParams,
          filterInEffect = _this$props.filterInEffect,
          hasPagination = _this$props.hasPagination,
          onChangeDisplayType = _this$props.onChangeDisplayType,
          resultsDisplayed = _this$props.resultsDisplayed,
          pSize = _this$props.pSize,
          showDownloadLink = _this$props.showDownloadLink,
          toggleFilter = _this$props.toggleFilter,
          totalCount = _this$props.totalCount,
          isLoadingData = _this$props.isLoadingData,
          isMulti = _this$props.isMulti,
          disabled = _this$props.disabled,
          valueOverride = _this$props.valueOverride,
          required = _this$props.required;
      var itemPerPageOptions = [{
        value: 20,
        label: '20'
      }, {
        value: 50,
        label: '50'
      }, {
        value: 100,
        label: '100'
      }, {
        value: 200,
        label: '200'
      }];
      var previousItemCount = pSize * (activePage - 1);

      var displayTypeIcons = function displayTypeIcons() {
        var iconsConfig = [{
          icon: 'list',
          type: 'list'
        }, {
          icon: 'bars',
          type: 'cards'
        }, {
          icon: 'table-rows',
          type: 'narrowCards'
        }];
        return /*#__PURE__*/React.createElement("div", {
          className: "p2 view-selector"
        }, /*#__PURE__*/React.createElement("span", {
          className: "view-label bold"
        }, i18n.t('View: ')), iconsConfig.map(function (config, index) {
          var isActive = config.type === activeDisplayType;
          return /*#__PURE__*/React.createElement(FAIcon, {
            key: index,
            icon: config.icon,
            onClick: function onClick() {
              return onChangeDisplayType(config.type);
            },
            color: isActive ? 'teal' : 'default',
            additionalClasses: isActive ? 'active' : ''
          });
        }));
      };

      var headerResults = hasPagination ? /*#__PURE__*/React.createElement("div", {
        className: "results p2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "results-label bold"
      }, i18n.t('Results: ')), i18n.t('%s of %s', {
        postProcess: 'sprintf',
        sprintf: ["".concat(previousItemCount + 1, " - ").concat(previousItemCount + dataSize), totalCount]
      })) : /*#__PURE__*/React.createElement("div", {
        className: "results p2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "results-label bold"
      }, i18n.t('Results:')), " ", totalCount);
      var itemsPerPage = /*#__PURE__*/React.createElement(Layout, {
        display: 'inline-flex',
        alignItems: 'flex-end',
        gap: DesignSystem.Sizes.XS
      }, /*#__PURE__*/React.createElement(Typography, {
        as: 'span',
        textStyle: 'ui-default'
      }, i18n.t('Items Per Page:')), /*#__PURE__*/React.createElement(Select, {
        isLoadingData: isLoadingData,
        multiple: isMulti,
        disabled: disabled,
        valueOverride: valueOverride,
        required: required,
        size: DesignSystem.Sizes.SM,
        width: DesignSystem.Space.SPACE_20,
        value: pSize,
        isClearable: false,
        name: "items_per_page",
        onChange: function onChange(event) {
          return _this2.onChange(event.target);
        }
      }, itemPerPageOptions.map(function (option) {
        return /*#__PURE__*/React.createElement("option", {
          key: option.value,
          "data-action": 'select-option-' + option.value,
          value: option.value
        }, option.label);
      })));
      var showHeader = resultsDisplayed || toggleFilter || filterInEffect || showDownloadLink;

      if (showHeader) {
        return /*#__PURE__*/React.createElement("div", {
          className: "pagination-header ".concat(activeDisplayType ? 'with-view-selector' : '')
        }, activeDisplayType && displayTypeIcons(), resultsDisplayed && headerResults, toggleFilter && /*#__PURE__*/React.createElement("span", {
          className: "filter-toggle"
        }, /*#__PURE__*/React.createElement("a", {
          onClick: toggleFilter
        }, filterDisplayed ? i18n.t('Hide Filters') : i18n.t('Show Filters'))), filterInEffect && /*#__PURE__*/React.createElement("span", {
          className: "filter-toggle"
        }, /*#__PURE__*/React.createElement("a", {
          onClick: clearFilters
        }, /*#__PURE__*/React.createElement(FAIcon, {
          icon: "undo"
        }), i18n.t('Reset Filters'))), /*#__PURE__*/React.createElement("div", {
          className: "right-items"
        }, showDownloadLink && /*#__PURE__*/React.createElement("div", {
          className: "download-link ui-default"
        }, /*#__PURE__*/React.createElement(ReportDownload, {
          downloadUrl: downloadUrl,
          downloadIcon: downloadIcon,
          downloadLabel: downloadLabel,
          downloadProcessing: downloadProcessing,
          downloadTimedOut: downloadTimedOut,
          downloadAction: downloadAction,
          downloadParams: downloadParams,
          closeTimeoutModal: closeTimeoutModal
        })), this.props.showPageSizeDropdown && itemsPerPage));
      } else {
        return null;
      }
    }
  }]);
}(React.Component);

_defineProperty(PaginationHeader, "propTypes", {
  activePage: PropTypes.number,
  activeDisplayType: PropTypes.string,
  changePageSize: PropTypes.func.isRequired,
  clearFilters: PropTypes.func,
  closeTimeoutModal: PropTypes.func,
  dataSize: PropTypes.number,
  downloadAction: PropTypes.func,
  downloadIcon: PropTypes.string,
  downloadLabel: PropTypes.string,
  downloadParams: PropTypes.any,
  downloadProcessing: PropTypes.bool,
  downloadTimedOut: PropTypes.bool,
  downloadUrl: PropTypes.string,
  filterDisplayed: PropTypes.bool,
  filterInEffect: PropTypes.bool,
  hasPagination: PropTypes.bool,
  onChangeDisplayType: PropTypes.func,
  pSize: PropTypes.number,
  resultsDisplayed: PropTypes.bool,
  showDownloadLink: PropTypes.bool,
  showPageSizeDropdown: PropTypes.bool,
  totalCount: PropTypes.number,
  toggleFilter: PropTypes.func,
  isLoadingData: PropTypes.bool,
  isMulti: PropTypes.bool,
  disabled: PropTypes.bool,
  valueOverride: PropTypes.bool,
  required: PropTypes.bool
});

_defineProperty(PaginationHeader, "defaultProps", {
  showPageSizeDropdown: true
});

PaginationHeader.displayName = "PaginationHeader";
export { PaginationHeader };